import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';

import { DecisionApplicationUnblockDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import DynamicTextarea from '../../../app/components/DynamicTextarea';
import { useTranslation } from '../../../common/hooks/useTranslation';
import {
  ApplicationUnblockStatusEnum,
  ApplicationUnblockStatusObj,
} from '../../../common/pokCore/validation/enums';
import { NewDatePicker } from '../../../app/components/NewDatePicker';

interface ApplicationUnblockDecisionFormProps {
  id?: string;
  applicationUnblock: DecisionApplicationUnblockDto;
  readOnly?: boolean;
  propertyChange: (obj: Partial<DecisionApplicationUnblockDto>) => void;
  globalSalesBlockedMonth?: boolean;
  globalPurchaseBlockedMonth?: boolean;
}

export const ApplicationUnblockDecisionForm: React.FC<
  ApplicationUnblockDecisionFormProps
> = props => {
  const { t, tk } = useTranslation('applicationLng');

  const applicationStatusOptions = [
    {
      value: ApplicationUnblockStatusEnum.Accepted,
      label: t(ApplicationUnblockStatusObj.Accepted),
    },
    {
      value: ApplicationUnblockStatusEnum.Rejected,
      label: t(ApplicationUnblockStatusObj.Rejected),
    },
  ];

  return (
    <>
      <Card className="card flex-grow-1 mt-3">
        <Card.Header>{t(tk.app.applicationExecution)}</Card.Header>
        <Card.Body className="m-1">
          <div className="d-grid gap-3 mb-3">
            <FormRow controlId="applicationStatus" label={t(tk.common.status)}>
              <Select
                value={
                  props.applicationUnblock?.status
                    ? applicationStatusOptions.find(
                        ({ value }) =>
                          props.applicationUnblock?.status === value,
                      )
                    : null
                }
                options={applicationStatusOptions}
                onChange={option =>
                  props.propertyChange({
                    status: option?.value,
                    rejectedNote: '',
                  })
                }
                placeholder={t(tk.component.pointOut)}
                isDisabled={props.readOnly}
              />
            </FormRow>
            {(props.globalPurchaseBlockedMonth ||
              props.globalSalesBlockedMonth) &&
              props.applicationUnblock.status ===
                ApplicationUnblockStatusEnum.Accepted && (
                <FormRow
                  controlId="dateToDelete"
                  label={t(tk.app.dateToDeleteBlockade)}
                >
                  <NewDatePicker
                    value={props.applicationUnblock?.dateToDelete}
                    dateChanged={value =>
                      props.propertyChange({ dateToDelete: value as Date })
                    }
                    readOnly={props.readOnly}
                  />
                </FormRow>
              )}
            {props.applicationUnblock.status ===
              ApplicationUnblockStatusEnum.Rejected && (
              <>
                <FormRow
                  controlId="rejectedNote"
                  label={t(tk.app.rejectedNote)}
                >
                  <DynamicTextarea
                    value={props.applicationUnblock.rejectedNote || ''}
                    onChange={e =>
                      props.propertyChange({
                        rejectedNote: e.target.value || '',
                      })
                    }
                    disabled={props.readOnly}
                  />
                </FormRow>
              </>
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
